export const ORDER_GUEST_DEFAULT_PHONE_NUMBER = '78126771000'
